import { m } from "framer-motion";
import Modal from "./Modal";
import ImageCarousel from "./ImageCarousel";

export default function CompanyModal({ company, open, onClose }) {
  if (!open || !company) return null;

  const { name, logo, photo, photos = [], url, summary, blurb } = company;
  const gallery = photos.length ? photos : (photo ? [photo] : []);

  return (
    <Modal open={open} onClose={onClose} titleId="company-modal-title">
      <m.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="relative overflow-hidden rounded-xl"
      >
           <div className="relative z-10 rounded-xl bg-white/85 backdrop-blur-sm p-6">
              {/* Carousel */}
            {gallery.length > 0 && (
              <div className="mb-6">
                <ImageCarousel images={gallery} altPrefix={`${name} image`} lbAspect="aspect-[16/9]" lbFit="cover" />
              </div>
            )}


          <div className="flex items-center gap-4 mb-4">
            {logo && (
              <img
                src={logo}
                alt={`${name} logo`}
                className="h-16 w-16 object-contain rounded-full ring-2 ring-blue-500/20"
              />
            )}
            <h2 id="company-modal-title" className="text-3xl font-bold text-gray-900">
              {name}
            </h2>
          </div>

          <p className="text-gray-600 mb-8 leading-relaxed">
            {summary || blurb}
          </p>

          <div className="flex gap-4">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-6 py-3 text-white font-semibold hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg"
            >
              Visit Site
            </a>
            <button
              onClick={onClose}
              className="inline-flex items-center gap-2 rounded-lg border border-gray-300 px-6 py-3 hover:bg-gray-50 transition-all duration-300"
            >
              Close
            </button>
          </div>
        </div>
      </m.div>
    </Modal>
  );
}
